/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <p>
      Click on the button below to proceed to the payment.<br>
      By proceeding, you accept the terms and conditions applying to the service, including our refund policy.
    </p>
    <p>
      <button
        class="btn btn-primary"
        :disabled="!stripeHandler"
        @click.prevent="openForm"
      >
        <svg
          class="icon-credit-card"
        >
          <use xlink:href="/static/svg-symbols.svg#icon-credit-card" />
        </svg>
        Pay by Credit Card
      </button>
    </p>
  </div>
</template>

<style lang="less" scoped>

.icon-credit-card {
  fill: white;
  position: relative;
  top: 2px;
  height: 14px; width: 14px;
}

</style>

<script>
export default {
  props: { 'email': String, 'plan': Object, 'callback': Function },
  data() {
    return {
      scriptInserted: false,
      stripeHandler: null
    };
  },
  mounted() {
    this.insertScript();
  },
  methods: {
    openForm() {
      this.$store.dispatch('getUser')
        .then(() => {
          this.$announcer.set('Payment form has been loaded in the current page');
          const email = this.$store.getters.user.email;
          this.stripeHandler.open({
            description: this.plan.name,
            amount: this.plan.price,
            email
          });
        });
    },
    insertScript() {
      if (this.scriptInserted) {
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.async = 1;
      script.onload = () => {
        this.stripeHandler = window.StripeCheckout.configure({
          key: this.$store.getters.appConfig.stripe.key,
          name: 'VoiceVibes',
          zipCode: true,
          // billingAddress: true,
          allowRememberMe: false,
          image: 'https://s3.amazonaws.com/stripe-uploads/acct_19DbZ4HHwkX2yio2merchant-icon-1481000999941-voicevibes-stripe.png',
          locale: 'auto',
          token: (token) => {
            this.callback(token.id);
          }
        });
      };
      script.onerror = () => {
        this.$store.dispatch('notify', {
          type: 'error',
          subject: 'A server error occurred',
          text: 'Please try again in a few minutes'
        });
      };
      document.body.appendChild(script);
      this.scriptInserted = true;
    }
  }
};
</script>
